import { Purpose } from 'src/app/api/autogenerated/types.gen';
import { DocumentDetails } from 'src/app/types/DocumentDetails';
import { FilePurpose } from 'src/app/types/FileTypes';
import { Invoice } from 'src/app/types/Invoice';
import { PaymentMethodDetails } from 'src/app/types/PaymentDetails';
import { Payout } from 'src/app/types/Payout';
import { FileUploadResponse } from 'src/app/types/responses/FileUploadResponse';

export abstract class IFileService {
  abstract uploadFile(
    file: File,
    purpose: FilePurpose,
    customerId?: string,
  ): Promise<FileUploadResponse>;
  abstract getFile(
    fileId: string,
    purpose: FilePurpose,
  ): Promise<DocumentDetails>;

  abstract getCustomerFileContent(
    customerId: string,
    fileId: string,
    purpose: Purpose,
    fileMetadata?: Pick<DocumentDetails, 'name' | 'mediaType' | 'size'>,
  ): Promise<DocumentDetails>;

  abstract getFilesByCustomerId(customerId: string): Promise<DocumentDetails[]>;

  abstract deleteFile(fileId: string): Promise<void>;

  abstract generateHdfcIrmReport(
    payout: Payout,
    invoice: Invoice,
    bankAccountDetails: PaymentMethodDetails,
    partnerName?: string,
  ): Promise<Blob>;

  abstract generateHdfcRequestLetter(
    payout: Payout,
    invoice: Invoice,
    bankAccountDetails: PaymentMethodDetails,
    partnerName?: string,
  ): Promise<Blob>;
}
